import React, { useEffect, useRef } from "react";
import { useState } from "react";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import styled from "styled-components";
import NFTNav from "../components/NavComponents/NFTNav";
import PerksList from "../components/desktop/PerksList";
import { io } from 'socket.io-client';
import { mintNFT, sendMessagePerk, airdropNFT } from '../utils/backendUtils';
import SocialConnectModalComponent from '../components/NavComponents/SocialConnectModalComponent'
import { getLoginInformation,
    setPaymentDetails,
    setWalletDetails,
    setSocialHandleInformation
} from '../utils/loginHelper';
import eventBus from '../utils/globalPubSub';
import Lottie from 'react-lottie';
import animationData from '../assets/loader.json';
import { useHistory } from "react-router-dom";
import { fethchGlipBox } from '../utils/backendUtils';

const url = window.location;
let domain = (new URL(url));
domain = domain.origin;


const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice"
    }
  };

const Mobile = styled.div`
  display: none;
  @media only screen and (max-device-width: 480px) {
    display: flex;
    height: 96vh;
    flex-direction: column;
  }
`;

const Title = styled.div`
    font-style: normal;
    font-weight: bold;
    font-size: 36px;

    display: flex;
    align-items: center;

    color: #FFFFFF;
    text-align: center;

`;

const Price = styled.div`
    font-style: normal;
    font-weight: 500;
    font-size: 20px;
    display: flex;
    align-items: center;

    color: #FFFFFF;
`;

const Subtitle = styled.div`
    font-family: IBM Plex Mono;
    font-style: normal;
    font-weight: 600;
    font-size: 15.5866px;
    line-height: 120%;
    /* or 19px */
   
    letter-spacing: -0.03em;

    color: #FFFFFF;

    color: #fff;
   
`;


const ActionBoxTitle = styled.div`
    font-family: IBM Plex Mono;
    font-style: normal;
    font-weight: bold;
    color: #FFFFFF;
    text-transform: uppercase;
`;

const ActionBoxSubtitle = styled.div`
    font-family: IBM Plex Mono;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 145%;
    /* or 20px */

    display: flex;
    align-items: center;
    text-align: center;

    color: #FFFFFF;

    opacity: 0.4;
    margin-top: 15px;
    margin-bottom: 24px;
`;


const ActionBox = styled.div`
    background: rgba(255, 255, 255, 0.08);
    border-radius: 12px;
    color: #FFFFFF;
    padding: 50px 40px;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
`;

const Desktop = styled.div`
  display: none;
  @media (min-device-width: 481px) {
    display: flex;
    flex-direction: column;
    height: 100vh;
    opacity: 0.8
    align-items: flex-end;
    padding-left: 50px;
  }
`;


const GradientButton = styled.div`
    background: linear-gradient(95.39deg, #001AFF 3.78%, #DB00FF 100%);
    border-radius: 12px;
    padding: 13px;
    width: 100%;
    color: #fff;
    display: flex;
    justify-content: center;
    margin-top: 31px;
`;


const Description = styled.div`
    font-family: 'IBM Plex Mono';
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 18px;
    display: flex;
    align-items: center;
    text-align: center;
    color: #FFFFFF;
    opacity: 0.4;
    margin-bottom: 32px;
`;


const BotBar = styled.div`
    font-family: 'IBM Plex Mono';
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 18px;
    display: flex;
    align-items: center;
    text-align: center;
    color: #FFFFFF;
    background: rgba(255, 255, 255, 0.04);
    padding: 15px;
    flex-direction: column;
    width: 100%;
`;

const BotBarTitle = styled.span`
    font-family: 'IBM Plex Mono';
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 18px;
    display: flex;
    align-items: center;
    text-align: center;

    color: #FFFFFF;

    opacity: 0.4;
    margin-bottom: 5px;
`;

const BotBarCount = styled.span`
    font-family: 'IBM Plex Mono';
    font-style: normal;
    font-weight: 700;
    font-size: 24px;
    line-height: 31px;
    display: flex;
    align-items: center;
    text-align: right;

    color: #FFFFFF;
`;

const CardWrapper = styled.span`
    width: 100%;
    margin: 16px 0px;
    height: 345px;
    /* width: 245px; */
    @media (min-device-width: 481px) {
        width: 245px;
        margin: 10px;
        height: 245px
    }
`;

function capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }

export default function PrimeList(props) {
    const [socialConnectModalOpen,
        setSocialConnectModalOpen] = useState(false);
    const [connected, setIsConnected] = useState(false);
    const [loading, setLoading] = useState(false);
    const [user, setUser] = useState({});
    const {username} = useParams();
    const history = useHistory();
    const [glipbox, setGlipbox] = useState();
    const [search, setSearch] = useState();
    const [passes, setPasses] = useState(
    [{'name': 'Affable', 'passId': '6245a10a3c4528caff894784'},
    {'name': 'AffordPlan', 'passId': '6245a10a3c4528caff894785'},
    {'name': 'Bookee', 'passId': '6245a10a3c4528caff894786'},
    {'name': 'Collpoll', 'passId': '6245a10a3c4528caff894787'},
    {'name': 'Dozee', 'passId': '6245a10a3c4528caff894788'},
    {'name': 'Ezetap', 'passId': '6245a10a3c4528caff894789'},
    {'name': 'Finagg', 'passId': '6245a10a3c4528caff89478a'},
    {'name': 'Freo', 'passId': '6245a10a3c4528caff89478b'},
    {'name': 'Glip', 'passId': '6245a10a3c4528caff89478c'},
    {'name': 'HackerEarth', 'passId': '6245a10a3c4528caff89478d'},
    {'name': 'Hiration', 'passId': '6245a10a3c4528caff89478e'},
    {'name': 'Hitwicket', 'passId': '6245a10a3c4528caff89478f'},
    {'name': 'KnightFIntech', 'passId': '6245a10a3c4528caff894790'},
    {'name': 'KredX', 'passId': '6245a10a3c4528caff894791'},
    {'name': 'mFine', 'passId': '6245a10a3c4528caff894792'},
    {'name': 'MyGate', 'passId': '6245a10a3c4528caff894793'},
    {'name': 'Niyo', 'passId': '6245a10a3c4528caff894794'},
    {'name': 'OTO', 'passId': '6245a10a3c4528caff894795'},
    {'name': 'PlanetSpark', 'passId': '6245a10a3c4528caff894796'},
    {'name': 'Poshn', 'passId': '6245a10a3c4528caff894797'},
    {'name': 'Quizizz', 'passId': '6245a10a3c4528caff894798'},
    {'name': 'Revos', 'passId': '6245a10a3c4528caff894799'},
    {'name': 'SmartOwner', 'passId': '6245a10a3c4528caff89479a'},
    {'name': 'Styledod', 'passId': '6245a10a3c4528caff89479b'},
    {'name': 'Sunstone', 'passId': '6245a10a3c4528caff89479c'},
    {'name': 'SurveySparrow', 'passId': '6245a10a3c4528caff89479d'},
    {'name': 'Swifter', 'passId': '6245a10a3c4528caff89479e'},
    {'name': 'Synup', 'passId': '6245a10a3c4528caff89479f'},
    {'name': 'Tracxn', 'passId': '6245a10a3c4528caff8947a0'},
    {'name': 'Tranzact', 'passId': '6245a10a3c4528caff8947a1'},
    {'name': 'Vidgyor', 'passId': '6245a10a3c4528caff8947a2'},
    {'name': 'Waggle', 'passId': '6245a10a3c4528caff8947a3'},
    {'name': 'WheelsEye', 'passId': '6245a10a3c4528caff8947a4'},
    {'name': 'Winuall', 'passId': '6245a10a3c4528caff8947a5'},
    {'name': 'WisdomCircle', 'passId': '6245a10a3c4528caff8947a6'},
    {'name': 'Zupay', 'passId': '6245a10a3c4528caff8947a7'},
    {'name': 'Zuper', 'passId': '6245a10a3c4528caff8947a8'},
    {'name': 'Prime', 'passId': '624650713c4528caff8947a9'},
]);

    const handleLogin = async (loginDetails)=>{
        setIsConnected(true);
        setUser(loginDetails.user);        
    }

    const handleLogout = ()=> {
        setIsConnected(false);
        setUser({});
        setSocialConnectModalOpen(false)
    }

    
    const handleClaimButtonClick = async () => {
        setLoading(true)        
        console.log('setSocialConnectModalOpen(true)')
        let loginData = getLoginInformation();
        console.log(loginData)
        if(loginData){
            // handleLogin(loginData);
            // Make backend API call to mint NFT
            console.log(loginData)
            const response = await airdropNFT(username, loginData.user);
            console.log('airdtop============', response)
            if(response.success)
                history.push(`/address/${loginData.user.username}`)
            console.log('mint api call')
        }
        setSocialConnectModalOpen(true);
    };

    useEffect(()=>{
        let loginData = getLoginInformation();
        if(loginData){
            handleLogin(loginData);
        }
        eventBus.on("user-logged-in",(data)=>{
            handleLogin(data);
        });
        eventBus.on("user-logged-out",()=>{
            handleLogout();
        })
        return ()=>{
            eventBus.remove("user-logged-in");
            eventBus.remove("user-logged-out");
        }
    },[]);


    let filtered_passes = passes.filter((item, index) => {
        if(!search) return true;
        return item.name.toLowerCase().includes(search.toLowerCase());
    });

    const pass_list = filtered_passes.map((item, index) => {
        return (
            <CardWrapper className="hover" onClick={() => history.push(`/primevp/mint/${item.name}`)} key={`list-${index}`} style={{
                display: 'flex',
                flexDirection: 'column',
                // margin: '10px 0px',
                alignItems: 'center',
                // margin: '24px 12px',
                // marginTop: 80,                
                border: '1px solid rgba(38, 38, 38, 1)',
                borderRadius: 12,
                position: 'relative',
                backgroundImage: `url('https://live-nft-hosted-assets.s3.ap-south-1.amazonaws.com/prime-anniversary/PVP_NFT_${item.name}.gif')`,
                backgroundSize: '100% 100%',
                display: 'flex',
                justifyContent: 'flex-end',
            }}>
                
                <div style={{justifyContent: 'space-between', display: 'flex', background: 'rgba(19, 19, 19, 1)', width: '100%', borderBottomLeftRadius: 12, borderBottomRightRadius: 12}}>
                    {/* <div style={{display: 'flex',
                                 flexDirection: 'column',
                                 justifyContent: 'center',
                                 alignItems: 'flex-start', marginLeft: 12,
                                 marginTop: 10, marginBottom: 10}}>
                    </div> */}
                    <div style={{display: 'flex',
                                 flexDirection: 'column',
                                 justifyContent: 'center',
                                 alignItems: 'flex-start', marginLeft: 12, marginRight: 12,
                                 marginTop: 10, marginBottom: 10}}>
                        <span style={{fontSize: 11, opacity: 0.4}}>Creator</span>
                        <span 
                            
                            style={{fontSize: 14, fontWeight: 500, marginTop: 2}}
                            onClick={() => {
                                window.analytics.track('creator_username_clicked', {
                                    type: 'web',
                                    from: 'Owned page card',
                                    location: window.location.href
                                });
                            }}
                            >
                                PrimeVP.nft
                        </span>                        
                    </div>
                    <div style={{display: 'flex',
                                 flexDirection: 'column',
                                 justifyContent: 'center',
                                 alignItems: 'flex-start', marginLeft: 12, marginRight: 12,
                                 marginTop: 10, marginBottom: 10}}>
                        <span style={{fontSize: 11, opacity: 0.4}}>Company</span>
                        <span 
                            
                            style={{fontSize: 14, fontWeight: 500, marginTop: 2}}
                            onClick={() => {
                                window.analytics.track('creator_username_clicked', {
                                    type: 'web',
                                    from: 'Owned page card',
                                    location: window.location.href
                                });
                            }}
                            >
                                {item.name}
                        </span>                        
                    </div>
                   
                </div>
            </CardWrapper>
        );
    });

    
    return (
        <>
        <Mobile>
            <NFTNav		    
                userChainId={1}
                showTabs={false}
                ownedTab={false}
            />

            <div style={{display: 'flex', justifyContent: 'center', marginTop: 28, padding: 22, paddingBottom: 0}}>
                <input
                    onChange={(e) => {setSearch(e.target.value)}}
                    style={{
                        border: '1px solid rgba(255,255,255, 0.3)',
                        borderRadius: 12,
                        padding: 8,
                        width: '100%',
                        background: 'transparent'
                    }} placeholder="Search company..."/>
            </div>
            <div style={{padding: 22}}>
                {pass_list}
            </div>
            
        </Mobile>       
        <Desktop style={{}}>
            <NFTNav		    
                userChainId={1}
                showTabs={false}
                ownedTab={false}
            />

            <div style={{display: 'flex', justifyContent: 'center', marginTop: 28, padding: 22, paddingBottom: 0}}>
                <input
                    onChange={(e) => {console.log(e.target.value);setSearch(e.target.value)}}
                    style={{
                        border: '1px solid rgba(255,255,255, 0.3)',
                        borderRadius: 12,
                        padding: 8,
                        width: '100%',
                        background: 'transparent'
                    }} placeholder="Search company..."/>
            </div>
            <div style={{padding: 22}}>
                <div
                    className={"desktop-item-list"}
                    style={{
                        display: "flex",
                        flex: 2,
                        flexDirection: "row",
                        marginTop: 30,
                        flexWrap: 'wrap',
                        marginLeft: -10,
                        marginRight: -10,
                    }}
                >
                {pass_list}
                </div>
            </div>
            
        </Desktop>
        </>
    );
}

